<script setup lang="ts">
const emit = defineEmits(['close'])

const onClose = () => {
  emit('close')
}
</script>

<template>
  <div class="overlay-mask" @click.self="onClose">
    <slot></slot>
  </div>
</template>

<style scoped>
.overlay-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* 191/255 ≈ 0.75 alpha black */
  background: rgba(0, 0, 0, 0.75);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 100px;
}

@media (min-width: 768px) {
  .overlay-mask {
    left: 80px; /* offset for PC sidebar */
  }
}
</style>
